module.exports = __webpack_public_path__ + "img/TD.88126700.png";